<template>
    <div class="widget">
        <div v-if="hasImage" class="image">
            <slot name="image" />
        </div>
        <div class="shows-column" :class="{ 'full-width': !hasImage }">
            <slot name="content" />
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        /**
         * Checks whether image slot is filled.
         *
         * @returns {boolean} Check result.
         */
        hasImage() {
            return !! this.$slots.image;
        },
    },
};
</script>
